"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../../Resource"));
const Custom_1 = __importDefault(require("../../decorators/Custom"));
const ValidationErrors_1 = require("../../../enums/Validation/ValidationErrors");
class CommunitySpouseDetailsCreateRequestResource extends Resource_1.default {
}
exports.default = CommunitySpouseDetailsCreateRequestResource;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommunitySpouseDetailsCreateRequestResource.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommunitySpouseDetailsCreateRequestResource.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommunitySpouseDetailsCreateRequestResource.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsNumberString)({ no_symbols: false }),
    (0, class_validator_1.IsPhoneNumber)("FR"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommunitySpouseDetailsCreateRequestResource.prototype, "mobilePhone", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, Custom_1.default)((value) => new Date(value) < new Date(), { message: ValidationErrors_1.EValidationError.mustBeInThePast }),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], CommunitySpouseDetailsCreateRequestResource.prototype, "birthDate", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(60, { context: [60] }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommunitySpouseDetailsCreateRequestResource.prototype, "birthPlace", void 0);
